/**
 * @generated SignedSource<<38e376adef5d77e39900210252da80f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "answers"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emailConsent"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emailTrackingConsent"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "answers",
    "variableName": "answers"
  },
  {
    "kind": "Variable",
    "name": "emailConsent",
    "variableName": "emailConsent"
  },
  {
    "kind": "Variable",
    "name": "emailTrackingConsent",
    "variableName": "emailTrackingConsent"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "success",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notice",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "needsAuthentication",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ValidationError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "field",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "messages",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MutationResult",
  "abstractKey": "__isMutationResult"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "needsToFillPostSignUpForm",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PostSignUpFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PostSignUpFormPayload",
        "kind": "LinkedField",
        "name": "postSignUpForm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PostSignUpFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PostSignUpFormPayload",
        "kind": "LinkedField",
        "name": "postSignUpForm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a43679a402df42b10091c71ba289029",
    "id": null,
    "metadata": {},
    "name": "PostSignUpFormMutation",
    "operationKind": "mutation",
    "text": "mutation PostSignUpFormMutation(\n  $answers: [AnswerInput]\n  $emailConsent: Boolean\n  $emailTrackingConsent: Boolean\n) {\n  postSignUpForm(answers: $answers, emailConsent: $emailConsent, emailTrackingConsent: $emailTrackingConsent) {\n    ... on MutationResult {\n      __isMutationResult: __typename\n      success\n      notice\n      needsAuthentication\n      errors {\n        field\n        messages\n      }\n    }\n    user {\n      needsToFillPostSignUpForm\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "2d7d6d29bb50c48687f051bde85894b6";

module.exports = node;
